<template>
    <div>
        <div v-if="owner != null">
            <div class="report-body">
                <template v-for="(item, index) in owner.owner_size_zones" :key="index">
                    <div class="individual-wrap">
                        <div class="individual__left-panel">
                            <div class="individual__left-panel-image">
                                <img src="@/assets/Cargo.svg" alt="cargo" />
                            </div>
                        </div>
                        <div class="individual__body">
                            <table class="report-table report-table__filter">
                                <thead>
                                    <tr class="report-table__head">
                                        <th>Size</th>
                                        <th>Zone</th>
                                        <th>Rank</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div class="report-table__filter-item dissabled">{{ item.owner_size.size.name }}</div>
                                        </td>
                                        <td>
                                            <div class="report-table__filter-item dissabled">{{ item.zone.name }}</div>
                                        </td>
                                        <td>
                                            <div class="report-table__filter-item-select">
                                                <VueMultiselect
                                                    v-model="item.rank"
                                                    :options="this.ranks"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <table class="report-table sub-table">
                                <thead>
                                    <!-- <colgroup>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col style="width: 50px;">
                                    </colgroup> -->
                                    <tr class="report-table__sub-head">
                                        <th>First Name</th>
                                        <th>Surname</th>
                                        <th>Email</th>
                                        <th>Telephone</th>
                                        <th>Skype</th>
                                        <th style="width: 10px;" class="unlink-field-header"></th>
                                        <!-- <th class="unlink-field-header"></th> -->
                                        <!-- <th v-for="item in fields" :key="item.id">
                                            <div>{{ item.label }}</div>
                                        </th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                    <template v-for="(individual, individualIndex) in item.individuals" :key="individualIndex">
                                        <tr>
                                            <td>{{ individual.first_name }}</td>
                                            <td>{{ individual.surname }}</td>
                                            <td>{{ individual.email }}</td>
                                            <td>{{ individual.telephone }}</td>
                                            <td>{{ individual.skype }}</td>
                                            <td class="unlink-field" @click="(e) => unlinkIndividual(index, individualIndex)">
                                                <span>
                                                    X
                                                </span>
                                            </td>
                                        </tr>
                                    </template>
                                    
                                    <!-- Show "Contacts not found" message when no individuals -->
                                    <tr v-if="!item.individuals || item.individuals.length === 0">
                                        <td colspan="6" class="no-contacts-message">
                                            <div class="no-contacts-content">
                                                <div class="no-contacts-icon">👥</div>
                                                <div class="no-contacts-text">Contacts not found</div>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- <tr>
                                        <td colspan="5">
                                            <AddIndividual :individuals="individuals" :selectedIndividuals="item.individuals"
                                                @addIndividual="individual => addIndividual(individual, index)"></AddIndividual>

                                        </td>
                                    </tr> -->
                                </tbody>
                            </table>
                             <AddIndividual :individuals="individuals" :selectedIndividuals="item.individuals"
                                                @addIndividual="individual => addIndividual(individual, index)"></AddIndividual>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
// import Multiselect from "@vueform/multiselect";
import AddIndividual from "./components/AddIndividual";
import Owner from "@/api/tradingPlatform/owner";
import OwnerSizeZone from "@/api/tradingPlatform/ownerSizeZone";
import VueMultiselect from "vue-multiselect";
import IndividualApi from '@/api/tradingPlatform/individual';

export default {
    name: "IndividualsForOwner",
    components: {
        // Multiselect,
        AddIndividual,
        VueMultiselect,
    },
    emits: ["collectIndividuals"],
    props: {
        rid: Number,
        individuals: Array,
    },
    data: function () {
        return {
            owner: null,
            individual: {},
            ranks: [0, 1, 2, 3],
        };
    },
    async mounted() {
        this.getData();
    },
    watch: {},
    computed: {
        ownersIndividuals() {
            let res = {};
            if (this.owner != null) {
                for (const oszKey in this.owner["owner_size_zones"]) {
                    if (Object.hasOwnProperty.call(this.owner["owner_size_zones"], oszKey)) {
                        res[this.owner["owner_size_zones"][oszKey]["id"]] = [];
                    }
                }

                for (const oszKey in this.owner["owner_size_zones"]) {
                    if (Object.hasOwnProperty.call(this.owner["owner_size_zones"], oszKey)) {
                        const individuals = this.owner["owner_size_zones"][oszKey]["individuals"];
                        for (const individualKey in individuals) {
                            if (Object.hasOwnProperty.call(individuals, individualKey)) {
                                const individual = individuals[individualKey];
                                if (Object.hasOwnProperty.call(res, this.owner["owner_size_zones"][oszKey]["id"])) {
                                    res[this.owner["owner_size_zones"][oszKey]["id"]].push(individual["id"]);
                                } else {
                                    res[this.owner["owner_size_zones"][oszKey]["id"]] = [];
                                    res[this.owner["owner_size_zones"][oszKey]["id"]].push(individual["id"]);
                                }
                            }
                        }
                    }
                }
            }
            return res;
        }
    },
    methods: {
        linkIndividualsToOwner() {
            IndividualApi.addIndividualsToOwnerSizeZones(this.owner["id"], this.ownersIndividuals);
        },
        getData() {
            Owner.getOwnerByRid(this.rid).then((response) => {
                this.owner = response.data["data"];
            });

        },
        addIndividual(individual, index) {
            this.owner["owner_size_zones"][index]["individuals"].push(individual);
            this.collectIndividuals(this.owner["owner_size_zones"][index]["id"], individual["id"]);
        },

        collectIndividuals(ownerSizeZoneId, individualId) {
            this.$emit("collectIndividuals", ownerSizeZoneId, individualId);
        },
        unlinkIndividual(sizeZoneIndex, individualIndex) {
            this.owner["owner_size_zones"][sizeZoneIndex]["individuals"].splice(individualIndex, 1);
        },
        async updateRanks() {
            let res = [];
            for (let key in this.owner.owner_size_zones) {
                let element = this.owner.owner_size_zones[key];
                res.push({
                    "id": element.id,
                    "rank": element.rank,
                });
            }

            if (res.length != 0) {
                OwnerSizeZone.update(res);
            }

        }
    },
};
</script>

<style scoped src="vue-multiselect/dist/vue-multiselect.css"></style>

<style scoped>

a {
    color: #42b983;
}

td {
    border-right: 1px solid #d3dfed;
    border-bottom: 1px solid #d3dfed;
    /* padding: 15px; */
}

.report-body {
    /* overflow-y: auto;
  overflow-x: auto; */
    position: relative;
    margin-top: 10px;
    padding-bottom: 10px;
}


.report-table.sub-table tbody>tr:first-child>td {
    border-top: 1px solid #d3dfed;
}

.report-table {
    table-layout: fixed;
    border-collapse: collapse;
    position: relative;
    width: 100%;
}

.report-table thead tr {
    position: relative;
}

th {
    position: sticky;
    z-index: 1;
    /* border: 0; */
    padding: 8px 16px;
    color: rgb(255, 255, 255);
    -webkit-font-smoothing: antialiased;
    cursor: default;
    vertical-align: middle;

    font-family: "Lato";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    /* color: #2d3757; */
    color: #6C6F7D;
}

.report-table td div {
    white-space: nowrap;
}

.report-table__head {
    position: sticky;
    z-index: 1;
    /* background: #f6faff; */
    text-align: left;
}

.report-table__sub-head {
    position: sticky;
    z-index: 1;
    background: #f6faff;
    text-align: left;
}

.report-table__sub-head th {
    padding: 12px 8px;
}

.report-table__filter td {
    padding: 0px 5px;
}

/* Align filter table columns with main table columns */
.report-table__filter {
    width: 98.5% !important;
    table-layout: fixed !important;
}

.sub-table td {
    padding: 10px 5px;
}
.add-individual-wrap {
    text-align: center;
}

.add-individual-btn {
    background: #2d3757;
    color: #f6faff;
    padding: 4px 16px;
}

.sub-table {
    margin-top: 20px;
}


.sub-table tbody {
    border-left: 1px solid #d3dfed;
}

.unlink-field {
    border: 0;
    border-top: 1px #fff solid;
    font-weight: bold;
    cursor: pointer;
}

.report-table.sub-table tbody>tr:first-child>td.unlink-field {
    border-top: 1px #fff solid;
}

.unlink-field span {
    visibility: hidden;
}

tr:hover>.unlink-field span {
    visibility: visible;
}

.unlink-field-header {
    border: 0 !important;
    background: #fff;
}


.report-table__filter td {
    border: 0;
    /* Prevent height changes when dropdown opens */
    height: auto !important;
    min-height: 42px !important;
    max-height: 42px !important;
}

.report-table__filter-item {
    background: #f6faff;
    padding: 12px 8px;
    border-radius: 2px;
    border: 1px solid #D3DFED;
}

.report-table__filter-item.dissabled {
    background: #eee;
}
.report-table__filter-item-select ::v-deep(.multiselect) {
    border: 0;
}

.report-table__filter-item-select ::v-deep(.multiselect__tags) {
    /* background: #f0f0f0; */
    border: 0;
    padding-top: 10px;
    padding-bottom: 11px;
    border-radius: 2px;
    border: 1px solid #D3DFED;
}

.report-table__filter-item-select ::v-deep(.multiselect__single) {
    margin: 0 !important;
    height: 20px !important; /* Fixed height for single element */
    line-height: 20px !important;
    /* padding: 11px 0 !important; Center vertically */
}

/* Override VueMultiselect input styles */
.report-table__filter-item-select ::v-deep(.multiselect_input) {
    margin: 0 !important;
    margin-bottom: 0 !important;
    font-size: 14px !important; /* Override font-size */
    height: 20px !important;
    line-height: 20px !important;
    /* padding: 11px 0 !important; */
    border: none !important;
    background: transparent !important;
}

.report-table__filter-item-select ::v-deep(.multiselect_input:focus),
.report-table__filter-item-select ::v-deep(.multiselect_single:focus) {
    margin: 0 !important;
    margin-bottom: 0 !important;
    font-size: 14px !important;
    height: 20px !important;
    min-height: 20px !important;
    max-height: 20px !important;
    line-height: 20px !important;
    /* padding: 11px 0 !important; */
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent !important;
}

/* Fix dropdown positioning to prevent content shift */
.report-table__filter-item-select ::v-deep(.multiselect__content-wrapper) {
    position: absolute !important; /* Use absolute positioning */
    z-index: 10000 !important; /* Very high z-index to appear above everything */
    /* Let VueMultiselect handle positioning automatically */
    top: auto !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    /* Ensure dropdown doesn't affect container height */
    height: auto !important;
    min-height: 0 !important;
}

.report-table__filter-item-select ::v-deep(.multiselect__content) {
    position: relative !important;
    max-height: 200px !important;
    overflow-y: auto !important;
}

.report-table__filter-item-select {
    position: relative;
    z-index: 10; /* Higher than table headers */
    height: 42px; /* Fixed height to prevent any shift */
    overflow: visible; /* Allow dropdown to show outside */
    /* Prevent content shift */
    min-height: 42px !important;
    max-height: 42px !important;
}

/* Ensure dropdown can open upward if needed */
.report-table__filter-item-select ::v-deep(.multiselect__content) {
    position: relative !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    /* Allow dropdown to open upward */
    transform-origin: top !important;
}

/* Allow VueMultiselect to position dropdown automatically */
.report-table__filter-item-select ::v-deep(.multiselect) {
    position: relative !important;
    height: 42px !important;
    min-height: 42px !important;
    max-height: 42px !important;
    z-index: 10 !important;
    /* Enable automatic positioning */
    overflow: visible !important;
    /* Prevent height changes */
    flex-shrink: 0 !important;
    flex-grow: 0 !important;
}

/* Override all multiselect input and single element styles */
.report-table__filter-item-select ::v-deep(.multiselect_input),
.report-table__filter-item-select ::v-deep(.multiselect_single),
.report-table__filter-item-select ::v-deep(.multiselect) {
    margin: 0 !important;
    margin-bottom: 0 !important;
    font-size: 14px !important;
    height: 20px !important;
    min-height: 20px !important;
    max-height: 20px !important;
    line-height: 20px !important;
    /* padding: 11px 0 !important; */
    border: none !important;
    background: transparent !important;
    box-sizing: border-box !important;
    vertical-align: top !important;
}

/* More specific override for font-size */
.report-table__filter-item-select ::v-deep(.multiselect.multiselect--active .multiselect_input),
.report-table__filter-item-select ::v-deep(.multiselect.multiselect--active .multiselect_single),
.report-table__filter-item-select ::v-deep(.multiselect.multiselect--above .multiselect_input),
.report-table__filter-item-select ::v-deep(.multiselect.multiselect--above .multiselect_single) {
    font-size: 14px !important;
    margin: 0 !important;
    margin-bottom: 0 !important;
}

/* Even more specific override for stubborn font-size */
.report-table__filter-item-select ::v-deep(.multiselect.multiselect--active.multiselect--above .multiselect_input),
.report-table__filter-item-select ::v-deep(.multiselect.multiselect--active.multiselect--above .multiselect_single),
.report-table__filter-item-select ::v-deep(.multiselect.multiselect--active.multiselect--below .multiselect_input),
.report-table__filter-item-select ::v-deep(.multiselect.multiselect--active.multiselect--below .multiselect_single) {
    font-size: 14px !important;
    margin: 0 !important;
    margin-bottom: 0 !important;
    font-family: inherit !important;
    touch-action: manipulation !important;
}



.report-table__filter-item-select ::v-deep(.multiselect__tags) {
    position: relative !important;
    z-index: 1 !important;
    height: 42px !important; /* Fixed height */
    min-height: 42px !important;
    max-height: 42px !important;
    overflow: hidden !important; /* Hide any overflow */
    /* Prevent height changes */
    flex-shrink: 0 !important;
    flex-grow: 0 !important;
}

/* Ensure dropdown doesn't affect layout */
.report-table__filter-item-select ::v-deep(.multiselect__content-wrapper) {
    position: absolute !important; /* Use absolute positioning */
    z-index: 9999 !important; /* Higher z-index to appear above table headers */
    /* Let VueMultiselect handle positioning automatically */
    top: auto !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
    border: 1px solid #ddd !important;
    border-radius: 4px !important;
    background: white !important;
}

.individual-wrap {
    display: flex;
    margin-top: 40px;
}

.individual__left-panel-image {
    padding-top: 40px;
    padding-right: 14px;
}

/* No contacts message styles */
.no-contacts-message {
    text-align: center;
    padding: 40px 20px;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
}

.no-contacts-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    color: #6c757d;
}

.no-contacts-icon {
    font-size: 32px;
    opacity: 0.6;
}

.no-contacts-text {
    font-size: 16px;
    font-weight: 500;
    font-style: italic;
}

/* Global override for VueMultiselect font-size in this component */
.report-table__filter-item-select .multiselect,
.report-table__filter-item-select .multiselect_input,
.report-table__filter-item-select .multiselect_single {
    font-size: 14px !important;
    margin: 0 !important;
    margin-bottom: 0 !important;
}

.report-table__filter-item-select ::v-deep(.multiselect__select::before) {
    z-index: 9999 !important;
}

div.multiselect--active ::v-deep(.multiselect__select) {
    z-index: 9999 !important;
    transform: rotate(180deg);
}

.multiselect__input {
    margin-bottom: 0 !important;
    font-size: 14px !important;
    height: 20px !important;
    min-height: 20px !important;
    max-height: 20px !important;
    line-height: 20px !important;
    border: none !important;
    background: transparent !important;
}

.multiselect__tags ::v-deep(.multiselect__input) {
    margin-bottom: 0 !important;
    font-size: 14px !important;
    height: 20px !important;
    min-height: 20px !important;
    max-height: 20px !important;
    line-height: 20px !important;
    border: none !important;
    background: transparent !important;
}
</style>

<!-- Global styles to override vue-multiselect input styles -->
<style>
.multiselect__tags .multiselect__input {
    margin-bottom: 0 !important;
    font-size: 14px !important;
    height: 20px !important;
    min-height: 19px !important;
    max-height: 19px !important;
    line-height: 20px !important;
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
}
</style>